module.exports = __webpack_public_path__ + "img/Online Ticket.9c1676b3.svg";